import c from './Process.module.css'
import { getProcessDescendants, getAncestorProcesses } from '../../utils/process'
import { AddProcess } from '../AddProcess/AddProcess'
import { Socket } from './Socket/Socket'
import { AddSockets } from './AddSockets/AddSockets'

export const Process = ({
  rtTaskId,
  output,
  rtProcess,
  dtProcess,
  descendantRtProcesses,
  descendantDtProcesses,
  dtSockets,
  rtSockets,
  hoveredProcessId,
  setHoveredProcessId,
  openSocketId,
  setOpenSocketId,
  onSocketFinalized,
  onRtProcessAndSocketsAdd,
  onRtSocketsAdd
}) => {
  let hovered = hoveredProcessId === rtProcess?.id;

  // check if hoveredProcessId is one of the descendant processes
  let isHoveredDescendant = descendantRtProcesses.some(proc => proc.id === hoveredProcessId);
  // check if hoveredProcessId is a new process that is a potential descendant of this process
  if (typeof (hoveredProcessId) === 'string' && hoveredProcessId.startsWith("[new]")) {
    // get what comes after the first occurrence of [childOf]
    const parentProcessIdOfPotentialNewProcess = hoveredProcessId.split("[childOf]")[1];
    isHoveredDescendant = descendantRtProcesses.some(proc => String(proc.id) === parentProcessIdOfPotentialNewProcess);
    // check if my own id is the same as the parentProcessIdOfPotentialNewProcess
    isHoveredDescendant = isHoveredDescendant || String(rtProcess?.id) === parentProcessIdOfPotentialNewProcess;
  }

  const handleMouseEnter = (event) => {
    event.stopPropagation();
    // console.log(rtProcess.name, output, dtSockets, dtSocketsIO)
    setHoveredProcessId(rtProcess?.id);
  }

  const handleMouseLeave = (event) => {
    event.stopPropagation();
    setHoveredProcessId(null);
  }

  const handleMouseMove = (event) => {
    event.stopPropagation();
    // console.log(rtProcess.name, output, dtSockets, dtSocketsIO)
    setHoveredProcessId(rtProcess?.id);
  }

  const rtProcesses = rtProcess ? [...descendantRtProcesses, rtProcess] : [...descendantRtProcesses];
  const dtProcesses = dtProcess ? [...descendantDtProcesses, dtProcess] : [...descendantDtProcesses];

  // get all input OR output sockets depending on "output" prop
  const dtSocketsIO = dtSockets.filter(dtSock => output ? dtSock.io === 'output' : dtSock.io === 'input');
  //console.log(rtProcess.name,output, dtSockets, dtSocketsIO)



  // get all process ids mentioned in sockets
  const processIdsLinkedToSocket = dtSocketsIO.map(dtSock => dtSock.process);

  // initialize an empty array to hold all ancestors
  let allAncestors = [];

  // loop through them and get the ancestors of each of them
  processIdsLinkedToSocket.forEach(processId => {
    const ancestors = getAncestorProcesses(processId, dtProcesses, dtProcess?.id);
    allAncestors = [...allAncestors, ...ancestors];
  });
  // console.log(rtProcess.name, allAncestors)

  // ancestors can be repeated so we need to remove duplicates (based on the "id" key)
  // ProcessesIO are the processes that can be present/created (if there is a socket attached to them or if they have children with sockets attached to them in the DT)
  const dtProcessesIO = allAncestors.filter((ancestor, index, self) => index === self.findIndex(t => t.id === ancestor.id));
  // console.log(output, dtProcessesIO);

  const dtProcessesDirectChildren = dtProcessesIO.filter(process => process.parentProcessId === (dtProcess ? dtProcess.id : null));

  let dtProcessesPossibleToAdd = dtProcessesDirectChildren.filter(
    dtProc => dtProc.isMultipliable ||
      !rtProcesses.some(rtProc => rtProc.dtId === dtProc.id && rtProc.parentProcessId === (rtProcess ? rtProcess.id : null))
  );

  /* 
  --------------------------------
  RT Processes and Sockets
  --------------------------------
  */

  // get all RT sockets that have dtId === one of dtSocketsIO.id
  const rtSocketsIO = rtSockets.filter(rtSock => dtSocketsIO.some(dtSock => dtSock.id === rtSock.dtId));
  // get all RT processes that have parentProcessId === null
  const rtProcessesDirectChildren = rtProcesses.filter(rtProc => rtProc.parentProcessId === (rtProcess ? rtProcess.id : null));
  // console.log(rtProcess ? rtProcess.name : "BASE", rtProcessesDirectChildren)
  //console.log(rtProcess.name, output, rtSocketsIO, rtProcessesDirectChildren)

  const rtSocketsLinkedToCurrentRtProcess = rtSocketsIO.filter(rtSock => rtSock.process === (rtProcess ? rtProcess.id : null));
  // console.log(rtProcess.name, output, rtSocketsLinkedToCurrentRtProcess)

  const dtSocketsLinkedToCurrentDtProcessIO = dtProcess ? dtSocketsIO.filter(dtSock => dtSock.process === dtProcess.id) : [];
  // console.log(dtSocketsLinkedToCurrentDtProcessIO, "for", dtProcess ? dtProcess.id : "null", "with all dtsocks", dtSocketsIO)

  const missingRtSockets = dtSocketsLinkedToCurrentDtProcessIO.filter(dtSock => !rtSocketsIO.some(rtSock => rtSock.dtId === dtSock.id));
  const isSocketsAvailableToAdd = missingRtSockets.length > 0;
  return (
    <div
      className={c['grid-ctr']}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={hoveredProcessId === null ? handleMouseMove : undefined}
    >
      <div className={c["left-color"]} style={{ backgroundColor: dtProcess?.color }}></div>
      <div className={c["ctr"]} >
        <div
          className={`
            ${c['header']} 
            ${hovered ? c["hovered-process"] : ""}
            ${isHoveredDescendant ? c["hovered-descendant"] : ""}`
          }
        >
          {dtProcess?.name} {dtProcess ? (dtProcess.isMultipliable ? "M" : <s>M</s>) : ""} {rtProcess ? <button onClick={() => { navigator.clipboard.writeText(rtProcess.id) }}>CP</button> : ""}
        </div>
        <div className={c['body']}>
          <div className={c['sockets-ctr']}>
            {
              rtSocketsLinkedToCurrentRtProcess.length > 0 &&
                rtSocketsLinkedToCurrentRtProcess.map(rtSock => {

                  const dtSock = dtSocketsIO.find(dtSock => dtSock.id === rtSock.dtId);

                  const isSocketSelected = openSocketId ? openSocketId === rtSock.id : null;
                  // console.log("is finalized", rtSock)
                  return (
                    <div className={[c['socket-ctr'], c[isSocketSelected ? "socket-selected" : ""]].join(" ")} key={rtSock.id}>
                      <Socket
                        rtTaskId={rtTaskId}
                        isFinalized={rtSock.isFinal}
                        onFinalize={onSocketFinalized}
                        output={output}
                        rtSocket={rtSock}
                        dtSocket={dtSock}
                        setOpenSocketId={setOpenSocketId}
                      />
                    </div>
                  )
                })
            }
            {
              isSocketsAvailableToAdd ?
                <div>
                  <AddSockets
                dtProcess={dtProcess}
                rtProcess={rtProcess}
                output={output}
                onRtSocketsAdd={onRtSocketsAdd}
                /> {missingRtSockets.map(sock => sock.name).join(",")}
                </div>: null
            }
          </div>
          <div className={c['child-processes-ctr']}>
            {

              dtProcessesDirectChildren.map((dtProcess, i) => {
                const rtProcessesDirectChildrenSameDtId = rtProcessesDirectChildren.filter(rtProc => rtProc.dtId === dtProcess.id);
                return (

                  <div
                    key={dtProcess.id}
                    className={c["unique-dt-process-section"]}
                  >
                    <div className={c["dt-process-name"]}>
                      {dtProcess.name}
                    </div>
                    <div className={c["processes-ctr"]}>
                      {
                        // display all RT processes that have dtId === dtProcess.id
                        rtProcessesDirectChildrenSameDtId.map((directChildRtProcess, i) => {
                          const descendantDtProcesses = getProcessDescendants(dtProcess.id, dtProcesses);
                          const descendantRtProcesses = getProcessDescendants(directChildRtProcess.id, rtProcesses);


                          const dtProcWithDesc = [dtProcess, ...descendantDtProcesses]
                          const rtProcWithDesc = [directChildRtProcess, ...descendantRtProcesses]

                          // i want all the sockets that are linked to descendantRtProcesses and the process at this level
                          const dtSocketsLinkedToDtProcesses = dtSocketsIO.filter(dtSock => dtProcWithDesc.some(dtProc => dtProc.id === dtSock.process));
                          const rtSocketsLinkedToRtProcesses = rtSocketsIO.filter(rtSock => rtProcWithDesc.some(descendantRtProc => descendantRtProc.id === rtSock.process));
                          //console.log("dt proc", output,dtProcesses,  getProcessDescendants(dtProcess.id, dtProcesses), dtSocketsLinkedToDtProcesses)
                          // console.log("rt proc", output,rtProcesses,  getProcessDescendants(directChildRtProcess.id, rtProcesses), rtSocketsLinkedToRtProcesses)

                          return (
                            <div className={c['process-ctr']} key={directChildRtProcess.id}>
                              <Process
                                rtTaskId={rtTaskId}
                                output={output}
                                rtProcess={directChildRtProcess}
                                dtProcess={dtProcess}
                                descendantRtProcesses={descendantRtProcesses}
                                descendantDtProcesses={descendantDtProcesses}
                                dtSockets={dtSocketsLinkedToDtProcesses}
                                rtSockets={rtSocketsLinkedToRtProcesses}
                                hoveredProcessId={hoveredProcessId}
                                setHoveredProcessId={setHoveredProcessId}
                                openSocketId={openSocketId}
                                setOpenSocketId={setOpenSocketId}
                                onSocketFinalized={onSocketFinalized}
                                onRtProcessAndSocketsAdd={onRtProcessAndSocketsAdd}
                                onRtSocketsAdd={onRtSocketsAdd}
                              />
                            </div>
                          )
                        })
                      }
                      {dtProcessesPossibleToAdd.find(dtProc => dtProc.id === dtProcess.id) &&
                        <AddProcess
                          output={output}
                          dtProcess={dtProcess}
                          parentRtProcess={rtProcess}
                          descendantProcesses={descendantDtProcesses}
                          hoveredProcessId={hoveredProcessId}
                          setHoveredProcessId={setHoveredProcessId}
                          onRtProcessAndSocketsAdd={onRtProcessAndSocketsAdd}
                        />}
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
}
